import Resource from "./Resource";
import ResourceCollection from "./ResourceCollection";
import Text from "./Text";
import TextSection from "./TextSection";
import Project from "./Project";
import Maker from "./Maker";
import User from "./User";
import Page from "./Page";
import Feature from "./Feature";
import TwitterQuery from "./TwitterQuery";
import ReadingGroup from "./ReadingGroup";
import JournalVolume from "./JournalVolume";
import Asset from "./Asset";

export default {
  Resource,
  ResourceCollection,
  Text,
  TextSection,
  Project,
  Maker,
  User,
  Page,
  Feature,
  TwitterQuery,
  ReadingGroup,
  JournalVolume,
  Asset
};
